import React from 'react';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { PUBLICATION_STATUS } from 'constants/constants';
import messages from './messages';

import {
  PublishStatusStyle,
  PublishStatusCircle,
  HollowCircle,
} from './styles';

const PublishStatusIcon = ({
  activity,
  theme,
}) => {
  const publicationDetails = activity?.publicationDetails;
  if (!publicationDetails) {
    return <></>;
  }
  const currentStatus = publicationDetails.oculusStatus;
  if (!currentStatus) {
    return (
      <HollowCircle>
        <PublishStatusStyle>Status Unknown</PublishStatusStyle>
      </HollowCircle>
    );
  }
  const renderStatus = (color, label) => (
    <PublishStatusCircle color={color}>
      <PublishStatusStyle>{label}</PublishStatusStyle>
    </PublishStatusCircle>
  );
  switch (currentStatus) {
    case PUBLICATION_STATUS.IN_REVIEW:
      return renderStatus(theme['color.magenta'], intl.formatMessage(messages.inReview));
    case PUBLICATION_STATUS.PUBLISHED_LIVE:
      return renderStatus(theme['color.green'], intl.formatMessage(messages.publishedLive));
    default:
      return null;
  }
};

export default PublishStatusIcon;
